import { getOrganizationMemberRequests } from 'api/patients';
import {
  convertIntoObjectWithPageInfo,
  returnAllDataFromResponse,
} from 'helpers/utils/reactQueryHelpers';
import { StatusEnum } from 'interfaces/enums';
import { IMemberAccessRequest } from 'interfaces/personalities';
import { IError, IInfiniteResult } from 'interfaces/response';
import { useInfiniteQuery } from 'react-query';
import QueryKeys from '../queryKeys';
import {
  OrganizationQueryParams,
  SearchAndPagingQueryParams,
} from 'interfaces/queryParams';
import { IQueryRequest } from 'interfaces/request';

interface UseGetInfiniteOrganizationMemberRequestsParams
  extends OrganizationQueryParams,
    SearchAndPagingQueryParams {
  status: StatusEnum | null;
}

function useGetInfiniteOrganizationMemberRequests({
  params,
  options,
}: IQueryRequest<UseGetInfiniteOrganizationMemberRequestsParams>) {
  const { organizationId, searchValue, pageSize, status } = params;
  const response = useInfiniteQuery<
    IInfiniteResult<IMemberAccessRequest[]>,
    IError
  >({
    ...options,
    queryKey: [
      QueryKeys.getOrganizationMemberRequests,
      organizationId,
      searchValue,
      pageSize,
      status,
    ],
    queryFn: async ({ pageParam = 1 }) => {
      const { data } = await getOrganizationMemberRequests(
        organizationId,
        {
          search: searchValue,
          page_size: pageSize,
          page: pageParam,
        },
        status
      );

      return convertIntoObjectWithPageInfo<IMemberAccessRequest[]>(data);
    },
    getNextPageParam: (lastPage) => {
      return lastPage.nextPage;
    },
    getPreviousPageParam: (firstPage) => firstPage.previousPage,
  });

  return {
    ...response,
    requests: returnAllDataFromResponse<IMemberAccessRequest>(response),
  };
}

export default useGetInfiniteOrganizationMemberRequests;
